export default "__VITE_ASSET__CdsSko3F__"